/**
 * SSO Providers Schema
 * Enterprise SSO configuration for SAML 2.0 and OIDC providers.
 *
 * Note: Neon Auth (Better Auth) does not currently support SAML/OIDC natively.
 * This schema stores provider configurations for when protocol support is added
 * (via Better Auth plugin or auth provider migration).
 */

import { pgTable, uuid, varchar, text, timestamp, boolean } from 'drizzle-orm/pg-core';

// =============================================================================
// SSO Providers Table
// =============================================================================
export const ssoProviders = pgTable('sso_providers', {
  id: uuid('id').primaryKey().defaultRandom(),
  name: varchar('name', { length: 255 }).notNull(),
  type: varchar('type', { length: 20 }).notNull(), // 'saml' | 'oidc'
  domain: varchar('domain', { length: 255 }).notNull(), // e.g. 'acme.com'
  metadataUrl: text('metadata_url'), // SAML metadata URL or OIDC discovery URL
  entityId: varchar('entity_id', { length: 512 }), // SAML entity ID
  clientId: varchar('client_id', { length: 255 }), // OIDC client ID
  // Note: client_secret should be stored in Doppler/KV, not in DB
  acsUrl: text('acs_url'), // SAML Assertion Consumer Service URL
  certificate: text('certificate'), // IdP signing certificate (PEM)
  enabled: boolean('enabled').notNull().default(false),
  jitProvisioning: boolean('jit_provisioning').notNull().default(true),
  defaultRole: varchar('default_role', { length: 50 }).notNull().default('standard'),
  createdAt: timestamp('created_at').defaultNow().notNull(),
  updatedAt: timestamp('updated_at').defaultNow().notNull(),
});

// =============================================================================
// Types
// =============================================================================
export type SsoProvider = typeof ssoProviders.$inferSelect;
export type NewSsoProvider = typeof ssoProviders.$inferInsert;
